import { constructExportMap } from '../constructExportMap';

export function constructRawHtmlExportMap()
{
    return constructExportMap();
}